/* eslint-disable @typescript-eslint/no-explicit-any */
// import { NewsArticle } from "app/[locale]/blog/type";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_PATH from "~/utils/api-routes";

interface BlogIntState {
  blogData: any[];
  isLoading: boolean;
  hasMore: boolean;
  totalRecord: number;
}
// interface BlogIntState {
//   blogData: NewsArticle[];
//   isLoading: boolean;
//   hasMore: boolean;
//   totalRecord: number;
// }

// create async thunk and make a api call get the .env variable
export const fetchBlogData = createAsyncThunk<any, any>("blog/fetchBlogData", async (payload) => {
  const response = await axios.get(`https://newsapi.org/v2/${API_PATH.BLOG}`, { params: payload });
  return { hasMore: response.data.totalResults > payload.page * 10, articles: response.data.articles, totalRecord: response.data.totalResults };
});

const initialState: BlogIntState = {
  blogData: [],
  isLoading: false,
  hasMore: true,
  totalRecord: 0,
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogData.pending, (state) => {
        state.blogData = [];
        state.isLoading = true;
      })
      .addCase(fetchBlogData.fulfilled, (state, action) => {
        state.blogData = action.payload.articles;
        state.hasMore = action.payload.hasMore;
        state.totalRecord = action.payload.totalRecord;
        state.isLoading = false;
      })
      .addCase(fetchBlogData.rejected, (state) => {
        state.blogData = [];
        state.isLoading = false;
      });
  },
});

export default blogSlice.reducer;
